import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  formatColumnTitle,
} from 'views/EMR/PopulateSupport/SupportPortalQueryExecutionSection';

function generateFilename(extension: string): string {
  const timestamp = new Date().toISOString().slice(0, 23)
    .replace('T', '-')
    .replace(/[:.]/g, '-');
  return `query-results-${timestamp}.${extension}`;
}

export function exportToCsv(headers: string[], rows: string[][]): void {
  const lines = [
    headers.map(formatColumnTitle).join(','),
    ...rows.map((row) => row.map(formatColumnTitle).join(',')),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = generateFilename('csv');
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function exportToPdf(headers: string[], rows: string[][], title?: string): void {
  const doc = new JsPDF({ orientation: 'landscape' });

  if (title) {
    doc.setFontSize(14);
    doc.text(title, 14, 15);
  }

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: title ? 22 : 14,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [30, 41, 59] },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    margin: { left: 14, right: 14 },
  });

  doc.save(generateFilename('pdf'));
}
